export const FETCH_MAP_STATISTICS_REQUEST = '@@dashboard/overview/FETCH_MAP_STATISTICS_REQUEST';
export const FETCH_MAP_STATISTICS_SUCCESS = '@@dashboard/overview/FETCH_MAP_STATISTICS_SUCCESS';
export const FETCH_MAP_STATISTICS_FAILURE = '@@dashboard/overview/FETCH_MAP_STATISTICS_FAILURE';
